import React, { FC } from 'react';
import ctaTypes from '../../../enums/CTA.enums';
import { getExternalLinkRelAttribute } from '../../../utils';
import RoutableNotEditableLink from '../routableNotEditableLink';
import ArrowRight from './components/LinkWithField/arrowRight';
import LinkWithField from './components/LinkWithField';
import { TCtaProps } from './types/cta.types';
import { getQueryLink } from '../../../utils/getQuerylink';

const CTA: FC<TCtaProps> = ({
  type,
  href,
  onClick,
  children,
  field,
  extraClassName,
  target,
  isArrowShown = true,
}) => {
  const ctaClassName = [ctaTypes['baseButton'], type, extraClassName].join(' ');
  const hasArrowRight = isArrowShown && (type === ctaTypes.secondaryRed || type === ctaTypes.secondaryWhite);
  field && getQueryLink(field)

  if (field) {
    return (
      <LinkWithField
        field={field}
        hasArrowRight={hasArrowRight}
        ctaClassName={ctaClassName}
        onClick={onClick}
        target={target}
        type={type}
      >
        {children}
      </LinkWithField>
    );
  } else {
    return (
      <RoutableNotEditableLink
        href={href}
        target={target}
        className={ctaClassName}
        onClick={onClick}
        {...getExternalLinkRelAttribute(href)}
      >
        {children}
        {hasArrowRight && <ArrowRight type={type} />}
      </RoutableNotEditableLink>
    );
  }
};

export { ctaTypes };
export default React.memo(CTA);
